import { ArrowLeft } from 'lucide-react';
import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';
import { PrivacySection } from '../components/PrivacySection';
import { privacyIntroduction, privacySections, privacyClosing } from '../content/privacy';

export default function PrivacyNotice() {
  return (
    <div className="landing-page">
      <SiteHeader />
      <main data-testid="privacy-notice-page" className="bg-white px-6 pb-20 pt-32 text-sm text-gray-700 sm:text-base">
        <article className="mx-auto max-w-4xl">
          <a data-testid="privacy-back-home-link" href="/" className="mb-8 inline-flex items-center gap-2 text-sm font-medium text-[#7c4a97]"><ArrowLeft aria-hidden="true" className="h-4 w-4" />GenMoney</a>
          <h1 data-testid="privacy-notice-heading" className="mb-4 text-4xl font-bold text-gray-900 sm:text-5xl lg:text-6xl">Privacy Notice</h1>
          <p data-testid="privacy-last-updated" className="mb-8 text-sm font-semibold text-[#604f9b]">GenMoney | Last updated: 1st October 2026</p>
          <div className="mb-10 space-y-4">{privacyIntroduction.map((text, index) => <p key={text} data-testid={`privacy-introduction-${index}`} className="leading-relaxed">{text}</p>)}</div>
          {privacySections.map((section, index) => <PrivacySection key={section.title} section={section} number={index + 1} />)}
          <p data-testid="privacy-closing-notice" className="border-t border-gray-200 pt-8 font-medium leading-relaxed text-gray-900">{privacyClosing}</p>
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}